module.exports = __webpack_public_path__ + "images/cupra_small99c1ef6ed3a6cbe7cfb3715f6e4c146f.png";